import { appServiceLines, commonEnums } from '@codametrix/ui-common';

const EDITABLE_PATHS: ReadonlySet<string> = new Set(['ipc', 'surgery']);

const EDITABLE_STATUSES: ReadonlySet<string> = new Set([
  commonEnums.Gen2ProcessStatus.AT_CODER,
  commonEnums.Gen2ProcessStatus.IN_PROGRESS
]);

export const facilityEditPermission = (
  run: CMxAPI.CaseRun | undefined
): 'allowed' | 'denied' => {
  if (!run?.caserun_uid) return 'denied';
  if (run.parent_caserun_uid) return 'denied';

  // `isIPC` misses the `'BedsidePro'` literal dev carries: its set holds `'Bedside Pro'` and
  // `normalizeServiceLineName` strips only hyphens. `determineServiceLineConfig` admits it.
  let amplifyPath: string | undefined;
  try {
    amplifyPath = appServiceLines.determineServiceLineConfig({
      name: run.service_line ?? '',
      caseIdentifier: String(run.case_id ?? '')
    })?.amplifyPath;
  } catch (error) {
    // It normalizes the name through `decodeURIComponent`, which throws on a stray `%`. This gate
    // runs unguarded during render, so a throw here would take the whole coding route down. Log
    // first: a silently swallowed throw is indistinguishable from a legitimate deny.
    console.error('Facility edit denied: service line lookup failed', error);
    return 'denied';
  }
  if (!EDITABLE_PATHS.has(amplifyPath ?? '')) return 'denied';

  return EDITABLE_STATUSES.has(run.process_status ?? '') ? 'allowed' : 'denied';
};
